import { useSearchParams } from 'react-router-dom';
import { useApp } from './AppContext';

/**
 * The week and region a screen shows, kept in the address so a link — from the
 * rollup to a count and back — lands on the same week. This week and all
 * regions are the defaults and stay out of the address.
 */
export function useWeekAndRegion() {
  const { reference } = useApp();
  const [params, setParams] = useSearchParams();
  const week = params.get('week') ?? reference.currentWeekEnding;
  const region = params.get('region') ?? 'all';

  const set = (key: 'week' | 'region', value: string) => {
    const next = new URLSearchParams(params);
    if (value === 'all' || (key === 'week' && value === reference.currentWeekEnding)) next.delete(key);
    else next.set(key, value);
    setParams(next, { replace: true });
  };

  return {
    week,
    region,
    setWeek: (value: string) => set('week', value),
    setRegion: (value: string) => set('region', value),
  };
}
